import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseHistogramStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram/fp-logger-noise-histogram.store';
import { FpLoggerNoiseHistogramActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram/fp-logger-noise-histogram.actions';
import { FpLoggerNoiseHistogramComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/components/fp-logger-noise-histogram/fp-logger-noise-histogram.component';
import { FpLoggerNoiseHistogramMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/components/fp-logger-noise-histogram-minimized/fp-logger-noise-histogram-minimized.component';
import { Observable } from 'rxjs';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseHistogramConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseHistogramStore);
  public currentTab = FpLoggerNoiseTabs.Histogram;

  public component: Type<unknown> = FpLoggerNoiseHistogramComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseHistogramMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpLoggerNoiseTabs): boolean {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger): void {
    this.tabStore.dispatch({
      type: FpLoggerNoiseHistogramActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger): void {
    this.tabStore.dispatch({
      type: FpLoggerNoiseHistogramActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
